import { render } from "./OblastRadaView.vue?vue&type=template&id=45d09d84&scoped=true"
import script from "./OblastRadaView.vue?vue&type=script&lang=js"
export * from "./OblastRadaView.vue?vue&type=script&lang=js"

import "./OblastRadaView.vue?vue&type=style&index=0&id=45d09d84&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Admin\\Desktop\\Development\\saska-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d09d84"]])

export default __exports__